<template>
  <div id="stream">
    <!-- Cover Photo -->
    <div class="cover-photo rellax" data-rellax-speed="0" :style="{
      backgroundImage:
        'url(' +
        require('../../assets/images/album/cover-photo/cover-photo.jpg') +
        ')',
    }">
      <div class="cover-photo-gradient"></div>
      <!-- Container -->
      <div id="cover-head" class="w-80" v-if="album != null">
        <section>
          <div class="title-block row">
            <div class="user-avatar mr-3">
              <div v-if="album.photographerAuth" style="
                    position: absolute;
                    left: 70px;
                    top: 70px;
                    border-radius: 100%;
                    z-index: 99999;
                    background-color: #238ae6;
                    width: 29px;
                    height: 30px;
                  ">
                <i class="el-icon-circle-check" style="font-size: 30px; color: white"></i>
              </div>
              <div class="avatar-wrapper">
                <router-link :to="{
      path: 'customerPublishLook',
      query: {
        authorName: album.sgL_Mem_DisplayName,
        authorId: album.sgL_Mem_Cid,
      },
    }">
                  <img v-lazy="album.userLogoBig" :onerror="$defaultUserLog" height="100%" width="100%" />
                </router-link>
              </div>
            </div>
            <h2 class="title album-name row">
              <div class="col-12">{{ album.sgL_PG_CName +  (album.sgL_PG_CPublicshare?'':'【私人，不公開相簿】') }}</div>
            </h2>
            <div class="metadata row">
              <div class="col-12">
                <router-link :to="{
      path: 'customerPublishLook',
      query: {
        authorName: album.sgL_Mem_DisplayName,
        authorId: album.sgL_Mem_Cid,
      },
    }">
                  <span class="username">{{ album.sgL_Mem_DisplayName }}</span>
                </router-link>
              </div>
            </div>
            <div class="metadata row">
              <div class="col-12">
                <span class="photo-count">{{ album.sgL_PG_CPhotoQuantity }}
                  {{ $t('Album.albumviewPhotoolds.Photo') }}</span>
                /
                <span class="view-count">{{ album.sgL_PG_CViewQuantity }} {{ $t('Album.albumviewPhotoolds.browse')
                  }}</span>
              </div>
            </div>
            <div class="subrow row justify-content-between">
              <div class="bydate">
                <div class="date">{{ album.sgL_PG_CAddTimerF }}</div>
                <div>
                  <div class="reward_center row mt-2">
                    <div class="toooltip" v-for="(item, idx) in medalListData" :key="idx">
                      <img :src="item.sgL_URL" style="width:40px;">
                      <span class="toooltiptext">{{ item.sgL_Title }}<br />
                        <span class="exchange_point b-operate-btn" type="button" @click="showExchangePoint(item.id)"
                          v-if="album.sgL_Mem_Cid == loginUser.userId">兌換為點數</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="iconbar">
                <div style="display: flex; justify-content: end; flex-wrap: wrap">
                  {{ shortWebUrl }}
                  <a href="javascript:;" @click="copyShortLink" style="margin-left: 5px">{{
      $t('Album.albumviewPhotoolds.copy') }}</a>
                </div>
                <div>
                  <ul class="action">
                    <li class="like" :title="$t('Album.albumviewPhotoolds.good')">
                      <a :title="$t('Album.albumviewPhotoolds.good')" href="javascript:void(0)" @click="
      addfavorite(
        album.id,
        album.sgL_PG_CMasterSort,
        0,
        null,
        1,
        'album.isLike'
      )
      "><i class="fas fa-thumbs-up mr-1" v-if="album.isLike"></i><i class="far fa-thumbs-up mr-1"
                          v-else>{{ $t('Album.albumviewPhotoolds.good') }}</i></a>
                    </li>
                    <li class="bookmark ml-4" :title="$t('Album.albumviewPhotoolds.collect')">
                      <a :title="$t('Album.albumviewPhotoolds.collect')" href="javascript:void(0)" @click="
      addfavorite(
        album.id,
        album.sgL_PG_CMasterSort,
        0,
        null,
        0,
        'album.isCollection'
      )
      "><i class="fas fa-bookmark fa-fw" v-if="album.isCollection"></i><i
                          class="far fa-bookmark fa-fw" v-else></i>{{ $t('Album.albumviewPhotoolds.collect') }}</a>
                    </li>
                    <li class="share ml-4" :title="$t('Album.albumviewPhotoolds.share')">
                      <a href="javascript:;" @click="share(album.id)">
                        <i class="fa fa-share mr-1"></i> {{ $t('Album.albumviewPhotoolds.share') }}
                      </a>
                    </li>
                    <li class="report ml-4" :title="$t('Album.albumviewPhotoolds.accuse')">
                      <a href="javascript:;" @click="report">
                        <i class="fa fa-flag mr-1"></i> {{ $t('Album.albumviewPhotoolds.accuse') }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </section>
      </div>
      <!-- ./Container -->
    </div>
    <div class="cover-nav" v-if="album != null">
      <div class="sub-nav">
        <div class="subnav-content w-80 mt-0">
          <div class="subnav-items-container">
            <el-tabs style="width: 100%" class="left row" v-model="activename" type="card" @tab-click="handleClick">
              <el-tab-pane :label="$t('Album.albumviewPhotoolds.Photoalbum')" name="photoList"> </el-tab-pane>
              <el-tab-pane :label="$t('Album.albumviewPhotoolds.Photo')" name="photo"></el-tab-pane>
              <el-tab-pane :label="$t('Album.albumviewPhotoolds.photoDetail')" name="photoDetail">
              </el-tab-pane>
            </el-tabs>
            <!-- <ul class="links" role="menubar">
                <a href="../album/albumview-photostream.html">
                  <li id="photostream" class="link selected" role="menuitem">
                    <span>相片</span>
                  </li>
                </a>
                <a href="../album/albumview-detail.html">
                  <li id="comments" class="link" role="menuitem">
                    <span>相簿描述 及 留言<span class="count">3</span></span>
                  </li>
                </a>
              </ul> -->
            <!-- <div
              class="album-operate-btn edit-btn"
              v-show="
                isPhoto &&
                this.user != null &&
                album.sgL_Mem_Cid == this.user.userId
              "
            >
              <router-link
                :to="{
                  name: 'uploadImage',
                  query: { id: albumId, tid: 3 },
                }"
              >
                <input
                  type="submit"
                  value="編輯/新增"
                  class="btn btn-secondary"
              /></router-link>
            </div>
            <div
              class="album-operate-btn delete-btn"
              v-show="
                isPhoto &&
                this.user != null &&
                album.sgL_Mem_Cid == this.user.userId
              "
            >
              <input
                type="submit"
                @click="deletePhoto()"
                value="刪除相簿"
                class="btn btn-danger"
              />
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div id="album-view" class="container-80 mt-5" data-rellax-speed="4" v-show="menuItem == 2" v-if="album != null">
      <section>
        <!-- 相片瀏覽 -->
        <div class="photo-showcase section-group">
          <div class="row">
            <div class="col-lg-6 pr-lg-2">
              <!-- 相簿內容 -->
              <div class="album-content card my-3 p-4">
                <h2 class="side-title">{{ $t('Album.albumviewPhotoolds.Albumdescription') }}</h2>
                <div v-if="album.sgL_PG_CContent != ''" class="album-description mb-2">
                  {{ album.sgL_PG_CContent }}
                </div>
                <div class="album-date my-1">
                  {{ $t('Album.albumviewPhotoolds.CShootTimerF') }}{{ album.sgL_PG_CShootTimerF }}
                </div>
                <div class="upload-date my-1">
                  {{ $t('Album.albumviewPhotoolds.CAddTimerF') }}{{ album.sgL_PG_CAddTimerF }}
                </div>
                <div class="album-category my-1">
                  {{ $t('Album.albumviewPhotoolds.CMasterSortStr') }}<a href="">{{ album.sgL_PG_CMasterSortStr }}</a>
                </div>
                <div class="my-1">
                  {{ $t('Album.albumviewPhotoolds.shortWebUrl') }}<a href="javascript:;" @click="copyShortLink"
                    style="margin-left: 10px">{{ shortWebUrl }}</a>
                </div>
                <div class="tag-line mt-1" v-show="album.sgL_KeywordArry != null">
                  {{ $t('Album.albumviewPhotoolds.keyword') }}<a class="tag" href=""
                    v-for="keyword in album.sgL_KeywordArry" :key="keyword">{{ keyword }}</a>
                </div>
              </div>
              <!-- ./相簿內容 -->
            </div>
            <div class="col-lg-6 pl-lg-2">
              <!-- 留言 -->
              <div class="related-video card my-3 p-4">
                <h2 class="side-title">{{ $t('Album.albumviewPhotoolds.leaveword') }}</h2>
                <userCommentsVue :props_qryParams="commentsParams" ref="comment" @submitComment="submitComment"
                  @submitComment2="submitComment2"></userCommentsVue>
                <!-- <hr class="divider" /> -->
                <!-- <div class="comment">
                  (這裡放 Facebook 留言插件)
                  <a
                    href="https://developers.facebook.com/docs/plugins/comments/"
                    >https://developers.facebook.com/docs/plugins/comments/</a
                  >
                </div> -->
                <!-- /.留言 -->
              </div>
            </div>
          </div>
        </div>
        <!-- /.相片瀏覽 -->
      </section>
    </div>

    <div id="album-view" class="container-80 mt-5 rellax" data-rellax-speed="4" v-show="menuItem == 1"
      v-if="album != null" v-loading="floading" element-loading-background="transparent">
      <section>
        <!-- 相片瀏覽 -->
        <div class="photo-showcase section-group bodyRow">
          <div class="row">
            <div class="section-subBysusan">
              <div class="snapshot section-group" style="display: flex; flex-direction: column">
                <div style="margin: 5px 0px">
                  <el-time-picker is-range v-model="date1" style="width: 100%;" range-separator="-"
                    :start-placeholder="$t('Album.albumviewPhotoolds.startdate')"
                    :end-placeholder="$t('Album.albumviewPhotoolds.enddate')" format="HH:mm" value-format="HH:mm:00"
                    @focus="dateFocus" @change="dateChange">
                  </el-time-picker>
                </div>
                <div>
                  <div class="form-box left" style="width: initial"
                    v-if="faceTypeArray.includes(album.sgL_PG_CMasterSort)">
                    <input class="form-label" v-model="SGL_PG_LPhotoKey"
                      :placeholder="$t('Album.albumviewPhotoolds.Bibsearch')" />
                    <div class="form-button bw-5 ptrl-1 ml--5" @click="searchkey">
                      <img src="../../assets/images/album/number_bib.gif" data-toggle="tooltip" data-placement="top"
                        title="" :data-original-title="$t('Album.albumviewPhotoolds.Bibsearch')" />
                    </div>
                    <div class="form-button bw-5 ptrl-1 ml-1" data-toggle="modal" @click="faceSearch"
                      v-if="faceTypeArray.includes(album.sgL_PG_CMasterSort)">
                      <img src="../../assets/images/album/face_reco.gif" data-toggle="tooltip" data-placement="top"
                        title="" :data-original-title="$t('Album.albumviewPhotoolds.Facesearch')" />
                    </div>
                    <div class="form-button bw-5 ptrl-1 ml-1" data-toggle="modal" @click="AuthCheck">
                      <img src="../../assets/images/album/authchek.png" data-toggle="tooltip" data-placement="top"
                        title=""
                        :data-original-title="`${$t('Album.albumviewPhotoolds.AuthCheck')} ${album.isNotAuth} ${$t('Album.albumviewPhotoolds.piece')}`" />
                    </div>
                    <span @click="GetBaiErrorPhoto" class="aaaaa">{{ $t('Album.albumviewPhotoolds.identified') }}{{
      album.isAuth }}{{ $t('Album.albumviewPhotoolds.piece') }}，
                      {{ $t('Album.albumviewPhotoolds.unrecognized') }}{{ album.notAuth }}{{
      $t('Album.albumviewPhotoolds.piece') }}，
                      {{ $t('Album.albumviewPhotoolds.unidentifiable') }}{{ album.isNotAuth
                      }}{{ $t('Album.albumviewPhotoolds.piece') }}</span>
                  </div>
                  <div class="album-operate-btn edit-btn" style="text-align: right" v-show="(isPhoto &&
      this.user != null &&
      album.sgL_Mem_Cid == this.user.userId) ||
      (loginUser && loginUser.isAdmin)
      ">
                    <router-link :to="{
      name: 'uploadImage',
      query: { id: albumId, tid: 3 },
    }">
                      <input type="submit" :value="$t('Album.albumviewPhotoolds.update')"
                        class="btn btn-secondary" /></router-link>
                    <input type="submit" @click="deletePhoto()" :value="$t('Album.albumviewPhotoolds.delete')"
                      class="btn btn-danger" />
                  </div>
                </div>
                <div class="sorting right">
                  {{ $t('Album.albumviewPhotoolds.sorting') }}&nbsp;
                  <el-button size="mini" @click="orderbyhot('')" :class="{ current: '' == Sorting }">{{
      $t('Album.albumviewPhotoolds.orderbyhot') }}{{
      "" == Sorting
        ? sortASC === "ascending"
          ? $t('Album.albumviewPhotoolds.asc')
          : $t('Album.albumviewPhotoolds.desc')
        : ""
    }}</el-button>
                  <el-button size="mini" @click="orderbyhot('QueriesCount')"
                    :class="{ current: 'QueriesCount' == Sorting }">{{ $t('Album.albumviewPhotoolds.Bypopularity') }}{{
      "QueriesCount" == Sorting
        ? sortASC === "ascending"
          ? $t('Album.albumviewPhotoolds.asc')
          : $t('Album.albumviewPhotoolds.desc')
        : ""
    }}</el-button>
                </div>
              </div>

              <div class="row mobile">
                <div class="col">
                  <div class="pa-05" v-for="photo in photoList" :key="photo.id">
                    <div class="photo-card">
                      <!-- <a
                        href="javascript:void(0)"
                        @click="imgDetail(photo.sgL_PG_Coid, photo.id)"
                        ><img :src="photo.imageUrl_P"
                      /></a> -->
                      <router-link target="_blank" :to="{
      name: 'photoview',
      query: { Coid: photo.sgL_PG_Coid, Liid: photo.id },
    }"><img v-lazy="photo.imageUrl_P" /></router-link>
                      <div class="pos-ab-fm">
                        <i class="fa fa-info-circle photo-info" data-toggle="tooltip" data-placement="right"
                          :title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"
                          :data-original-title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"></i>
                      </div>
                      <div class="interaction-bar">
                        <div class="interaction-control">
                          <a class="interaction-icon view" :title="$t('Album.albumviewPhotoolds.browse')">
                            <i class="fa fa-eye fa-fw"></i>
                            <span class="view-count">
                              {{ photo.sgL_PG_Hits }}
                            </span>
                          </a>
                          <a :title="$t('Album.albumviewPhotoolds.collect')" href="javascript:void(0)"
                            class="interaction-icon bookmark" @click="
      addfavorite(
        photo.sgL_PG_Coid,
        album.sgL_PG_CMasterSort,
        1,
        photo.id,
        0,
        'photo.isCollection'
      )
      "><i class="fas fa-bookmark fa-fw" v-if="photo.isCollection"></i><i v-else
                              class="far fa-bookmark fa-fw"> </i>
                            <span class="bookmark-count" v-if="photo.isCollection">
                              {{ photo.sgL_PG_Favorite }} </span><span v-else></span></a>
                          <a v-if="getDownloadImage(photo.downUrl).length >= 1"
                            :href="getDownloadImage(photo.downUrl)[0]" class="interaction-icon download-hd"
                            :title="$t('Album.albumviewPhotoolds.DownloadHD')">
                            <img src="../../assets/images/icons/icon-download-hd.png" width="32" />
                          </a>
                          <a v-if="getDownloadImage(photo.downUrl).length === 2 &&
      getIsShowOrg(photo.sgL_PG_LShootTimer)
      " class="interaction-icon download-full"
                            :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                            :href="getDownloadImage(photo.downUrl)[1]">
                            <img src="../../assets/images/icons/icon-download-full.png" width="32" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pc">
                <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
                  <div class="pa-05" v-for="photo in photoList1" :key="photo.id">
                    <div class="photo-card">
                      <router-link target="_blank" :to="{
      name: 'photoview',
      query: { Coid: photo.sgL_PG_Coid, Liid: photo.id },
    }"><img v-lazy="photo.imageUrl_P" /></router-link>
                      <div class="pos-ab-fm">
                        <i class="fa fa-info-circle photo-info" data-toggle="tooltip" data-placement="right"
                          :title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"
                          :data-original-title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"></i>
                      </div>
                      <div class="interaction-bar">
                        <div class="interaction-control">
                          <a class="interaction-icon view" :title="$t('Album.albumviewPhotoolds.browse')">
                            <i class="fa fa-eye fa-fw"></i>
                            <span class="view-count">
                              {{ photo.sgL_PG_Hits }}
                            </span>
                          </a>
                          <a :title="$t('Album.albumviewPhotoolds.collect')" href="javascript:void(0)"
                            class="interaction-icon bookmark" @click="
      addfavorite(
        photo.sgL_PG_Coid,
        album.sgL_PG_CMasterSort,
        1,
        photo.id,
        0,
        'photo.isCollection'
      )
      "><i class="fas fa-bookmark fa-fw" v-if="photo.isCollection"></i><i v-else
                              class="far fa-bookmark fa-fw"> </i>
                            <span class="bookmark-count" v-if="photo.isCollection">
                              {{ photo.sgL_PG_Favorite }} </span><span v-else></span></a>
                          <a v-if="getDownloadImage(photo.downUrl).length >= 1"
                            :href="getDownloadImage(photo.downUrl)[0]" class="interaction-icon download-hd"
                            :title="$t('Album.albumviewPhotoolds.DownloadHD')">
                            <img src="../../assets/images/icons/icon-download-hd.png" width="32" />
                          </a>
                          <a v-if="getDownloadImage(photo.downUrl).length === 2 &&
      getIsShowOrg(photo.sgL_PG_LShootTimer)
      " class="interaction-icon download-full"
                            :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                            :href="getDownloadImage(photo.downUrl)[1]">
                            <img src="../../assets/images/icons/icon-download-full.png" width="32" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
                  <div class="pa-05" v-for="photo in photoList2" :key="photo.id">
                    <div class="photo-card">
                      <router-link target="_blank" :to="{
      name: 'photoview',
      query: { Coid: photo.sgL_PG_Coid, Liid: photo.id },
    }"><img v-lazy="photo.imageUrl_P" /></router-link>
                      <div class="pos-ab-fm">
                        <i class="fa fa-info-circle photo-info" data-toggle="tooltip" data-placement="right"
                          :title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"
                          :data-original-title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"></i>
                      </div>
                      <div class="interaction-bar">
                        <div class="interaction-control">
                          <a class="interaction-icon view" :title="$t('Album.albumviewPhotoolds.browse')">
                            <i class="fa fa-eye fa-fw"></i>
                            <span class="view-count">
                              {{ photo.sgL_PG_Hits }}
                            </span>
                          </a>
                          <a :title="$t('Album.albumviewPhotoolds.collect')" href="javascript:void(0)"
                            class="interaction-icon bookmark" @click="
      addfavorite(
        photo.sgL_PG_Coid,
        album.sgL_PG_CMasterSort,
        1,
        photo.id,
        0,
        'photo.isCollection'
      )
      "><i class="fas fa-bookmark fa-fw" v-if="photo.isCollection"></i><i v-else
                              class="far fa-bookmark fa-fw"> </i>
                            <span class="bookmark-count" v-if="photo.isCollection">
                              {{ photo.sgL_PG_Favorite }} </span><span v-else></span></a>
                          <a v-if="getDownloadImage(photo.downUrl).length >= 1"
                            :href="getDownloadImage(photo.downUrl)[0]" class="interaction-icon download-hd"
                            :title="$t('Album.albumviewPhotoolds.DownloadHD')">
                            <img src="../../assets/images/icons/icon-download-hd.png" width="32" />
                          </a>
                          <a v-if="getDownloadImage(photo.downUrl).length === 2 &&
      getIsShowOrg(photo.sgL_PG_LShootTimer)
      " class="interaction-icon download-full"
                            :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                            :href="getDownloadImage(photo.downUrl)[1]">
                            <img src="../../assets/images/icons/icon-download-full.png" width="32" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
                  <div class="pa-05" v-for="photo in photoList3" :key="photo.id">
                    <div class="photo-card">
                      <router-link target="_blank" :to="{
      name: 'photoview',
      query: { Coid: photo.sgL_PG_Coid, Liid: photo.id },
    }"><img v-lazy="photo.imageUrl_P" /></router-link>
                      <div class="pos-ab-fm">
                        <i class="fa fa-info-circle photo-info" data-toggle="tooltip" data-placement="right"
                          :title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"
                          :data-original-title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"></i>
                      </div>
                      <div class="interaction-bar">
                        <div class="interaction-control">
                          <a class="interaction-icon view" :title="$t('Album.albumviewPhotoolds.browse')">
                            <i class="fa fa-eye fa-fw"></i>
                            <span class="view-count">
                              {{ photo.sgL_PG_Hits }}
                            </span>
                          </a>
                          <a :title="$t('Album.albumviewPhotoolds.collect')" href="javascript:void(0)"
                            class="interaction-icon bookmark" @click="
      addfavorite(
        photo.sgL_PG_Coid,
        album.sgL_PG_CMasterSort,
        1,
        photo.id,
        0,
        'photo.isCollection'
      )
      "><i class="fas fa-bookmark fa-fw" v-if="photo.isCollection"></i><i v-else
                              class="far fa-bookmark fa-fw"> </i>
                            <span class="bookmark-count" v-if="photo.isCollection">
                              {{ photo.sgL_PG_Favorite }} </span><span v-else></span></a>
                          <a v-if="getDownloadImage(photo.downUrl).length >= 1"
                            :href="getDownloadImage(photo.downUrl)[0]" class="interaction-icon download-hd"
                            :title="$t('Album.albumviewPhotoolds.DownloadHD')">
                            <img src="../../assets/images/icons/icon-download-hd.png" width="32" />
                          </a>
                          <a v-if="getDownloadImage(photo.downUrl).length === 2 &&
      getIsShowOrg(photo.sgL_PG_LShootTimer)
      " class="interaction-icon download-full"
                            :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                            :href="getDownloadImage(photo.downUrl)[1]">
                            <img src="../../assets/images/icons/icon-download-full.png" width="32" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
                  <div class="pa-05" v-for="photo in photoList4" :key="photo.id">
                    <div class="photo-card">
                      <router-link target="_blank" :to="{
      name: 'photoview',
      query: { Coid: photo.sgL_PG_Coid, Liid: photo.id },
    }"><img v-lazy="photo.imageUrl_P" /></router-link>
                      <div class="pos-ab-fm">
                        <i class="fa fa-info-circle photo-info" data-toggle="tooltip" data-placement="right"
                          :title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"
                          :data-original-title="`${photo.sgL_PG_LPhotoName}${photo.sgL_PG_LPhotoOldExtensionName} ${photo.sgL_PG_LShootTimerF}`"></i>
                      </div>
                      <div class="interaction-bar">
                        <div class="interaction-control">
                          <a class="interaction-icon view" :title="$t('Album.albumviewPhotoolds.browse')">
                            <i class="fa fa-eye fa-fw"></i>
                            <span class="view-count">
                              {{ photo.sgL_PG_Hits }}
                            </span>
                          </a>
                          <a :title="$t('Album.albumviewPhotoolds.collect')" href="javascript:void(0)"
                            class="interaction-icon bookmark" @click="
      addfavorite(
        photo.sgL_PG_Coid,
        album.sgL_PG_CMasterSort,
        1,
        photo.id,
        0,
        'photo.isCollection'
      )
      "><i class="fas fa-bookmark fa-fw" v-if="photo.isCollection"></i><i v-else
                              class="far fa-bookmark fa-fw"> </i>
                            <span class="bookmark-count" v-if="photo.isCollection">
                              {{ photo.sgL_PG_Favorite }} </span><span v-else></span></a>
                          <a v-if="getDownloadImage(photo.downUrl).length >= 1"
                            :href="getDownloadImage(photo.downUrl)[0]" class="interaction-icon download-hd"
                            :title="$t('Album.albumviewPhotoolds.DownloadHD')">
                            <img src="../../assets/images/icons/icon-download-hd.png" width="32" />
                          </a>
                          <a v-if="getDownloadImage(photo.downUrl).length === 2 &&
      getIsShowOrg(photo.sgL_PG_LShootTimer)
      " class="interaction-icon download-full"
                            :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                            :href="getDownloadImage(photo.downUrl)[1]">
                            <img src="../../assets/images/icons/icon-download-full.png" width="32" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div
                  class="py-1 imageDataSource"
                  v-for="photo in photoList"
                  :key="photo.id"
                >
                  <div class="photo-card PListitem">
                    <router-link
                      :to="{
                        name: 'photoview',
                        query: { Coid: photo.sgL_PG_Coid, Liid: photo.id },
                      }"
                    >
                      <img :src="photo.imageUrl_P" class="initImg" />
                    </router-link>
                    <div class="interaction-bar">
                      <div class="photo-details">
                        <div class="title">ID:{{ photo.id }}</div>
                        <div class="time">{{ photo.sgL_PG_LShootTimerF }}</div>
                      </div>
                      <div class="interaction-control">
                        <a class="interaction-icon view" :title="$t('Album.albumviewPhotoolds.browse')">
                          <i class="fa fa-eye fa-fw"></i>
                          <span class="view-count">
                            {{ photo.sgL_PG_Hits }}
                          </span></a
                        >

                        <a
                          :title="$t('Album.albumviewPhotoolds.collect')"
                          href="javascript:void(0)"
                          class="interaction-icon bookmark"
                          @click="
                            addfavorite(
                              album.id,
                              album.sgL_PG_CMasterSort,
                              1,
                              photo.id,
                              0
                            )
                          "
                          ><i
                            class="fas fa-bookmark fa-fw"
                            v-if="photo.isCollection"
                          ></i
                          ><i v-else class="far fa-bookmark fa-fw"> </i>
                          <span
                            class="bookmark-count"
                            v-if="photo.isCollection"
                          >
                            {{ photo.sgL_PG_Favorite }} </span
                          ><span v-else></span
                        ></a>
                        <a
                          v-if="
                            photo.downUrl != null && photo.downUrl.length == 2
                          "
                          class="interaction-icon download-hd"
                          :title="$t('Album.albumviewPhotoolds.DownloadHD')"
                          :href="photo.downUrl[0]"
                        >
                          <img
                            src="../../assets/images/icons/icon-download-hd.png"
                            width="32"
                          />
                        </a>
                        <a
                          v-if="
                            photo.downUrl != null && photo.downUrl.length == 3
                          "
                          class="interaction-icon download-hd"
                          :title="$t('Album.albumviewPhotoolds.DownloadHD')"
                          :href="photo.downUrl[1]"
                        >
                          <img
                            src="../../assets/images/icons/icon-download-hd.png"
                            width="32"
                          />
                        </a>
                        <a
                          v-if="
                            photo.downUrl != null && photo.downUrl.length == 1
                          "
                          :href="photo.downUrl[0]"
                          class="interaction-icon download-full"
                          :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                        >
                          <img
                            src="../../assets/images/icons/icon-download-full.png"
                            width="32"
                          />
                        </a>
                        <a
                          v-if="
                            photo.downUrl != null && photo.downUrl.length == 2
                          "
                          :href="photo.downUrl[1]"
                          class="interaction-icon download-full"
                          :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                        >
                          <img
                            src="../../assets/images/icons/icon-download-full.png"
                            width="32"
                          />
                        </a>
                        <a
                          v-if="
                            photo.downUrl != null && photo.downUrl.length == 3
                          "
                          :href="photo.downUrl[2]"
                          class="interaction-icon download-full"
                          :title="$t('Album.albumviewPhotoolds.Downloadlossless')"
                        >
                          <img
                            src="../../assets/images/icons/icon-download-full.png"
                            width="32"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- /.相片瀏覽 -->
      </section>
    </div>

    <div id="album-view" class="container-80 mt-5 rellax" data-rellax-speed="4" v-show="menuItem == 3"
      v-loading="floading" element-loading-background="transparent">
      <section>
        <!-- 相片瀏覽 -->
        <div class="photo-showcase section-group bodyRow">
          <div class="row">
            <div class="section-subBysusan" style="margin-bottom: 50px">
              <div class="sorting right">
                {{ $t('Album.albumviewPhotoolds.sorting') }}&nbsp;
                <el-button size="mini" @click="orderbyhot2('')" :class="{ current: '' == Sorting2 }">{{
      $t('Album.albumviewPhotoolds.orderbyhot') }}</el-button>
                <el-button size="mini" @click="orderbyhot2('QueriesCount')"
                  :class="{ current: 'QueriesCount' == Sorting2 }">{{ $t('Album.albumviewPhotoolds.Bypopularity')
                  }}</el-button>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-6 col-md-4 col-lg-3 col-xl-2" v-for="item in data3" :key="item.id">
              <albumviewPhotostreamItemVue :item="item"></albumviewPhotostreamItemVue>
            </div>
          </div>
        </div>
        <div class="col">
          <pagination v-if="pageParams3.pageshow" :currentPage="pageParams3.currentPage" :pager-count="5"
            :total="pageParams3.total" :limit="pageParams3.limit" :small="true"
            @handleCurrentChange="handleCurrentChange3" @handleSizeChange="handleSizeChange3" />
        </div>
        <!-- /.相片瀏覽 -->
      </section>
    </div>

    <!-- Album Page Bar -->
    <div class="album-pagination" v-show="isPhoto">
      <div class="pagination-bar">
        <div class="row">
          <!-- 篩選拍攝時間 -->
          <div class="">
            <div class="time-filter dropup"></div>
          </div>
          <!-- /.篩選拍攝時間 -->

          <!-- 頁碼 -->
          <div class="col-12" isPhoto style="
                margin: auto;
                display: flex;
                justify-content: center;
                align-items: center;
              ">
            <div>
              <pagination v-if="getPageShow" :currentPage="pageParams.currentPage" :pager-count="4"
                :pageSizes="pageParams.pageSizes" :total="pageParams.total" :limit="pageParams.limit" :small="true"
                :prev-text="$t('Album.albumviewPhotoolds.prevtext')"
                :next-text="$t('Album.albumviewPhotoolds.nexttext')" @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange" />
            </div>
            <div class="inputPageDiv mobile" v-if="getPageShow">
              <el-input-number v-model="numPage" size="mini" :controls="false" controls-position="right"
                :min="1"></el-input-number>
            </div>
            <div style="margin-left: 5px" class="mobile" v-if="getPageShow">
              <el-link type="primary" @click="goPage">{{ $t('Album.albumviewPhotoolds.Clicktogo') }}</el-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.Album Page Bar -->
    <div id="alarmModal" class="modal">
      <div class="modal-content2 modal-content-sm">
        <span class="closebtn" @click="closealarmModal">&times;</span>
        <p class="text-content">{{ $t('Album.albumviewPhotoolds.textcontent') }}</p>
        <div class="btn" @click="Login">{{ $t('Album.albumviewPhotoolds.Login') }}</div>
      </div>
    </div>
    <albumviewFaceRecognitionVue ref="face" @faceSearchResult="faceSearchResult"></albumviewFaceRecognitionVue>
    <ReportVue ref="report" :props_title="$t('Album.albumviewPhotoolds.title')"></ReportVue>
    <medalView ref="medalView" @onMedalSubmit="GetEventMedalsByUser"></medalView>
  </div>
</template>

<script>
import pagination from "../common/Page";
import rowid from "rowgrid.js";
import userCommentsVue from "../common/userComments.vue";
import albumviewPhotostreamItemVue from "./albumviewPhotostreamItem.vue";
import albumviewFaceRecognitionVue from "./albumviewFaceRecognition.vue";
import base from "../../api/httpApi/base";
import ReportVue from "../common/Report.vue";
import ClipboardJS from "clipboard";
import medalView from "../Social/medalView";
export default {
  data() {
    return {
      date1: "",
      numPage: null,
      shortWebUrl: "",
      GridOptions: {
        itemSelector: ".PListitem",
        minMargin: 4,
        maxMargin: 1,
        firstItemClass: "first-item",
        lastRowClass: "imglastclass",
      },
      commentsParams: {
        SGL_PG_Coid: this.$route.query.id,
        SGL_Msg_Type: 0,
      },
      faceTypeArray: [10217, 10218, 10228, 10240],
      activename: "photo",
      TimeSearch: null,
      user: null,
      isPhoto: true,
      Sorting: "",
      Sorting2: "",
      floading: true,
      photoList: null,
      photoList1: [],
      photoList2: [],
      photoList3: [],
      photoList4: [],
      album: null,
      albumId: null,
      menuItem: 1,
      SGL_PG_LPhotoKey: null,
      faceFile: null,
      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 36,
        total: 0,
        pageshow: false,
        pageSizes: [12, 36, 72],
      },
      data3: null,
      pageParams3: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      sortASC: "ascending",
      medalListData: [],
      Runningwater: {},
      SGL_Is_AuthCheck: false,
    };
  },
  created() {
    this.urlCheck();
    this.user = this.$store.getters.getcustomer;
    this.$store.dispatch("updateCurrentIndex", 4);
    this.albumId = this.$route.query.id;
    this.shortWebUrl = this.getSortLink(this.albumId);

  },
  async mounted() {
    await this.getAlbumPhoto();
    this.GetEventMedalsByUser();
    this.getPicturePublish();
    this.$nextTick(() => {
      $("[data-toggle='tooltip']").tooltip();
    });
  },
  watch: {
    //    eventid(newvalue, oldvalue) {
    //   if (newvalue != oldvalue) {
    //     this.GetEvent();
    //   }
    // },
    TimeSearch: {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.getAlbumPhoto();
        }
      },
    },
    photoList: {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.imgUrlLoad(newvalue);
        }
      },
    },
  },
  components: {
    pagination,
    userCommentsVue,
    albumviewPhotostreamItemVue,
    albumviewFaceRecognitionVue,
    ReportVue,
    medalView
  },
  methods: {
    async GetBaiErrorPhoto() {
      this.$api.albumApi
        .GetBaiErrorPhoto({
          coid: this.albumId,
          //coid: 123123,
        })
        .then((res) => {
          if (res.data.success) {
            if (res.data.result) {
              let msg = ``;
              res.data.result.forEach((item, ix) => {
                msg += `${ix + 1}：（${item.sgL_ErrorCode}）${item.sgL_ErrorMsg
                  }<br />`;
              });
              if (msg) {
                this.$alert(msg, "說明", {
                  dangerouslyUseHTMLString: true,
                  showConfirmButton: false,
                  customClass: "abcd",
                });
              }
            }
          }
        });
    },
    dateChange() {
      this.getAlbumPhoto();
    },
    dateFocus() {
      /* if (!this.date1) {
        this.date1 = [new Date(2022, 1, 1, 1, 0), new Date(2022, 1, 1, 23, 59)];
      } */
    },
    getBeforeDate(n) {
      var date = new Date();
      var year, month, day;
      date.setDate(date.getDate() - n);
      year = date.getFullYear();
      month = date.getMonth() + 1;
      day = date.getDate();
      let s =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    getIsShowOrg(dt) {
      if (!dt) {
        return false;
      }
      const a = dt.replace("T", " ");
      const b = this.getBeforeDate(365);
      if (new Date(a) >= new Date(b)) {
        return true;
      } else {
        return false;
      }
    },
    getDownloadImage(arr) {
      if (!arr || arr.length === 0) {
        return [];
      }
      if (arr.length === 1 || arr.length === 2) {
        return arr;
      }
      return [...arr.slice(arr.length - 2)];
    },
    goPage() {
      this.handleCurrentChange(this.numPage);
    },
    copyShortLink() {
      this.copyToClipboard(this.shortWebUrl, true);
    },
    urlCheck() {
      if (this.$route.query.currentPage) {
        if (
          this.$route.query.activename &&
          this.$route.query.activename === "photoList"
        ) {
          this.pageParams3.currentPage = Number(this.$route.query.currentPage);
        } else {
          this.pageParams.currentPage = Number(this.$route.query.currentPage);
        }
      }
      if (this.$route.query.activename) {
        this.activename = this.$route.query.activename;
        if (this.activename === "photoList") {
          this.menuItem = 3;
          this.isPhoto = false;
          this.pageParams3.limit = 12;
        } else if (this.activename === "photo") {
          this.menuItem = 1;
          this.isPhoto = true;
          this.pageParams.limit = 50;
        }
      }
      if (this.$route.query.currentSize) {
        if (
          this.$route.query.activename &&
          this.$route.query.activename === "photoList"
        ) {
          this.pageParams3.limit = Number(this.$route.query.currentSize);
        } else {
          this.pageParams.limit = Number(this.$route.query.currentSize);
        }
      }
      if (this.$route.query.Sorting) {
        if (
          this.$route.query.activename &&
          this.$route.query.activename === "photoList"
        ) {
          this.Sorting2 = this.$route.query.Sorting;
        } else {
          this.Sorting = this.$route.query.Sorting;
        }
      }
      if (this.$route.query.sortASC) {
        this.sortASC = this.$route.query.sortASC;
      }
    },
    share(id) {
      let urlb = escape(`/Home/facebookResp?id=${id}&type=photo`);
      //console.log(1111111111, `${vue.$shareUrl}${bases.url}${urlb}`);
      window.open(`${this.$shareUrl}${base.url}${urlb}`, "_blank");
    },
    report() {
      if (this.CheckUserIsLogin()) {
        this.$refs.report.init(
          this.album.id,
          this.album.sgL_Mem_DisplayName,
          0,
          null
        );
      }
    },
    imgUrlLoad(data) {
      if (data) {
        this.photoList1 = [];
        this.photoList2 = [];
        this.photoList3 = [];
        this.photoList4 = [];
        let n = 1;
        for (let i = 0; i < data.length; i++) {
          this["photoList" + n].push(data[i]);
          n++;
          if (n === 5) {
            n = 1;
          }
        }
      }
      /* if (data) {
        if (base.env == "dev") {
          return data;
        } else {
          for (let key in data) {
            let item = data[key];
            item.imageUrl_P = item.imageUrl_P
              .replace("http://", "")
              .replace("https://", "");
            item.imageUrl_P =
              base.url +
              item.imageUrl_P.substring(item.imageUrl_P.indexOf("/"));
          }
          return data;
        }
      }
      return null; */
    },
    faceSearchResult(file, data) {
      this.faceFile = file;
      this.photoList = data.photoGalleryListDtl.items;
      this.pageParams.currentPage = 1;
      this.pageParams.total = 0;
      if (this.photoList) {
        this.pageParams.total = this.photoList.length;
        if (this.pageParams.total > 1) {
          this.pageParams.pageshow = true;
        }
      }
      this.$nextTick(() => {
        $("[data-toggle='tooltip']").tooltip();
      });
    },
    imgDetail(id1, id2) {
      this.$router.push({
        name: "photoview",
        query: {
          Coid: id1,
          Liid: id2,
        },
      });
    },
    faceSearch() {
      this.faceFile = null;
      this.SGL_PG_LPhotoKey = "";
      this.$refs.face.clear();
      this.$refs.face.show(this.album.id);
    },
    closealarmModal() {
      $("#alarmModal").modal("hide");
    },
    Login() {
      this.closealarmModal();
      this.$router.push({
        path: "/customerLogin",
        query: { redirect: this.$route.fullPath },
      });
    },
    getPicturePublish() {
      let params = {
        SGL_Mem_Cid: this.album.sgL_Mem_Cid,
        SkipCount: (this.pageParams3.currentPage - 1) * this.pageParams3.limit, //从第几条开始查，
        MaxResultCount: this.pageParams3.limit, //查多少条
        sorting: this.Sorting2,
      };
      this.$api.albumApi
        .getPicturePublishLook(params)
        .then((res) => {
          if (res.data.success) {
            this.data3 = res.data.result.items;
            this.pageParams3.total = res.data.result.totalCount;
            this.$nextTick(() => {
              $("[data-toggle='tooltip']").tooltip();
            });
            if (this.pageParams3.total >= 1) {
              this.pageParams3.pageshow = true;
            }
          } else {
          }
        })
        .catch((re) => { });
    },
    deletePhoto() {
      this.$confirm("確定刪除嗎？")
        .then((_) => {
          var _this = this;
          let params = {
            Id: this.albumId,
          };
          this.$api.VideoApi.DeletePhoto(params).then((res) => {
            if (res.data.success) {
              this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
              if (!this.loginUser.isAdmin) {
                this.$router.push({ name: "customerPublish" });
              } else {
                this.$router.go(-1);
              }
            } else {
              this.$message({ type: "error", message: res.data.error.message });
            }
          });
        })
        .catch((_) => { });
    },
    searchkey() {
      this.pageParams.currentPage = 1;
      this.getAlbumPhoto();
    },
    AuthCheck() {
      this.pageParams.currentPage = 1;
      this.SGL_Is_AuthCheck = !this.SGL_Is_AuthCheck;
      this.getAlbumPhoto();
    },
    async getAlbumPhoto() {
      this.faceFile = null;
      var _this = this;
      let params = {
        Id: this.albumId,
        TimeSearch: this.TimeSearch,
        SGL_Is_AuthCheck: this.SGL_Is_AuthCheck,
        SGL_PG_LPhotoKey: this.SGL_PG_LPhotoKey,
        Sorting: this.Sorting,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_PG_CPublicshare: true,
        sortASC: this.sortASC,
        SGL_AddTimerDate: this.date1,
      };
      await this.$api.albumApi.GetPhotoGalleryList(params).then((res) => {
        if (res.data.success) {
          this.floading = false;
          this.album = res.data.result;
          // var metaogimage = document.getElementsByName("ogimage");
          // metaogimage[0].content = this.album.photoImage;
          this.photoList = res.data.result.photoGalleryListDtl.items;
          this.pageParams.total = res.data.result.photoGalleryListDtl.totalCount;
          if (this.pageParams.total > 1) {
            this.pageParams.pageshow = true;
          }
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },

    DrawImage(ImgD, iwidth, iheight) {
      var flag = false;
      var image = new Image();
      //var iwidth = 620;            //定义允许图片宽度，当宽度大于这个值时等比例缩小
      //var iheight = 360;            //定义允许图片高度，当宽度大于这个值时等比例缩小
      var minwidth = iwidth; //图片最小宽度小于定义百分比；
      var minheight = iheight; //图片最小高度小于定义百分比
      image.src = ImgD.attr("src");
      if (image.width > 0 && image.height > 0) {
        //假如图片长宽都不为零
        flag = true;
        if (image.height / image.width >= iheight / iwidth) {
          //通过正弦值判断图片缩放后是否偏高
          if (image.height > iheight) {
            //如果图片比设定的要高
            ImgD.height = iheight;
            ImgD.width = (image.width * iheight) / image.height;
            ImgD.css("width", ImgD.width);
            // ImgD.css('height',ImgD.height);
          } else {
            //假如图片width<70%(设定)&&heitht<70%(设定)
            if (image.height < minheight) {
              ImgD.height = minheight;
              ImgD.width = (image.width * minheight) / image.height;
              ImgD.css("width", ImgD.width);
              // ImgD.css('height',ImgD.height);
            } else {
              ImgD.width = image.width;
              ImgD.height = image.height;
              ImgD.css("width", ImgD.width);
              // ImgD.css('height',ImgD.height);
            }
          }

          //                    ImgD.alt = image.width + "×" + image.height;
        } else {
          //如果图片比例 小于 设定的比例
          if (image.width > iwidth) {
            ImgD.width = iwidth;
            ImgD.height = (image.height * iwidth) / image.width;
            ImgD.css("width", ImgD.width);
            // ImgD.css('height',ImgD.height);
          } else {
            //假如图片width<70%(设定)&&heitht<70%(设定)
            if (image.width <= minwidth) {
              ImgD.width = minwidth;
              ImgD.height = (image.height * minwidth) / image.width;
              ImgD.css("width", ImgD.width);
              // ImgD.css('height',ImgD.height);
            } else {
              ImgD.width = image.width;
              ImgD.height = image.height;
              ImgD.css("width", ImgD.width);
              // ImgD.css('height',ImgD.height);
            }
          }
          //                    ImgD.alt = image.width + "×" + image.height;
        }
      } else {
        ImgD.css("width", minwidth);
        ImgD.css("height", iheight);
      }
    },
    download(url) {
      var alink = document.createElement("a");
      alink.href = url;
      alink.download = "pic"; //图片名
      alink.click();
    },
    orderbyhot(str) {
      if (this.faceFile) {
        this.$refs.face.fileToBase64(this.faceFile);
      } else {
        if (str === this.Sorting) {
          this.sortASC =
            this.sortASC === "ascending" ? "descending" : "ascending";
        } else {
          this.sortASC = "ascending";
        }
        this.Sorting = str;
        this.getAlbumPhoto();
      }
      this.pageRemeber(false);
    },
    orderbyhot2(str) {
      this.Sorting2 = str;
      this.getPicturePublish();
      this.pageRemeber3(false);
    },
    pageRemeber(isTop = true) {
      this.historyPushState(
        this.setUrlPar({
          currentPage: this.pageParams.currentPage,
          activename: this.activename,
          currentSize: this.pageParams.limit,
          Sorting: this.Sorting,
          sortASC: this.sortASC,
        })
      );
      if (isTop) {
        window.scrollTo(0, 0);
      }
    },
    pageRemeber3(isTop = true) {
      this.historyReplaceState(
        this.setUrlPar({
          currentPage: this.pageParams3.currentPage,
          activename: this.activename,
          currentSize: this.pageParams3.limit,
          Sorting: this.Sorting2,
        })
      );
      if (isTop) {
        window.scrollTo(0, 0);
      }
    },
    async showExchangePoint(Id) {
      this.$refs.medalView.setData(Id);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getAlbumPhoto();
      this.pageRemeber();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getAlbumPhoto();
      this.pageRemeber();
    },
    handleCurrentChange3(val) {
      this.pageParams3.currentPage = val;
      this.getPicturePublish();
      this.pageRemeber3();
    },
    handleSizeChange3(val) {
      this.pageParams3.limit = val;
      this.pageParams3.currentPage = 1;
      this.getPicturePublish();
      this.pageRemeber3();
    },
    handleClick(tab, event) {
      if (tab.label == this.$t('Album.albumviewPhotoolds.Photo')) {
        this.activename = "photo";
        this.menuItem = 1;
        this.isPhoto = true;
        this.pageParams.limit = 50;
        this.Sorting = "";
        this.handleCurrentChange(1);
      } else if (tab.label == this.$t('Album.albumviewPhotoolds.photoDetail')) {
        this.activename = "photoDetail";
        this.isPhoto = false;
        this.menuItem = 2;
      } else if (tab.label === this.$t('Album.albumviewPhotoolds.Photoalbum')) {
        this.$router.push({
          path: "customerPublishLook",
          query: {
            authorId: this.album.sgL_Mem_Cid,
          },
        });
        /* this.menuItem = 3;
        this.activename = "photoList";
        this.isPhoto = false;
        this.pageParams3.limit = 12;
        this.Sorting2 = "";
        this.handleCurrentChange3(1); */
      }
      /*       this.historyPushState(
        this.setUrlPar({ activename: this.activename, currentPage: 1 })
      );
      this.urlCheck(); */
    },
    addfavorite(tid, type, Ftype, longid, DevicesType, test) {
      //判断是否登陆，然后弹窗提示登陆
      if (this.user == null) {
        $("#alarmModal").modal("show");
        return;
      }

      let params = {
        sgL_DevicesType: DevicesType,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
          //this.getAlbumPhoto();
          if (test) {
            const a = test.split(".")[0];
            const b = test.split(".")[1];
            this[a][b] = !this[a][b];
          }
        }
      });
    },
    async GetEventMedalsByUser() {
      const { data: { result } } = await this.$api.common.GetEventMedalsByUser({ 'usersId': this.album.sgL_Mem_Cid });
      this.medalListData = result;
    },

    submitComment(data) {
      let params = {
        sgL_PG_CBigsort: this.album.sgL_PG_CMasterSort,
        //SGL_Msg_Belongidc: 31381350,
        sgL_PG_Coid: this.albumId,
        sgL_Msg_Type: 0,
        sgL_Msg_MContent: data,
        sgL_Msg_SendType: 0,
        SGL_Mem_FinallyReceive_Cid: this.album.sgL_Mem_Cid,
      };
      this.$refs.comment.submit(params);
    },
    submitComment2(
      data,
      sgL_Msg_ReplyMsgid,
      sgL_Mem_FinallyReceive_Cid,
      sgL_Mem_Reply_Cid
    ) {
      let params = {
        sgL_PG_CBigsort: this.album.sgL_PG_CMasterSort,
        //SGL_Msg_Belongidc: 31381350,
        sgL_PG_Coid: this.albumId,
        sgL_Msg_Type: 0,
        sgL_Msg_MContent: data,
        sgL_Msg_ReplyMsgid: sgL_Msg_ReplyMsgid,
        sgL_Mem_FinallyReceive_Cid: sgL_Mem_FinallyReceive_Cid,
        sgL_Mem_Reply_Cid: sgL_Mem_Reply_Cid,
        sgL_Msg_SendType: 1,
      };
      this.$refs.comment.submit(params);
    },
  },
  computed: {
    getPageShow() {
      return this.pageParams.pageshow;
    },
  },
};
</script>

<style scoped>
.photo-card {
  position: relative;
}

.PListitem {
  position: relative;
  float: left;
  margin-bottom: 0px;
  box-shadow: #ccc 1px 1px 15px;
}

.PListitem .initImg {
  /*  width: 25vw;
        height: 25vw;
        vertical-align: top;*/
  height: 300px;
}

.first-item {
  clear: both;
}

.PListitem img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: bottom;
  padding-right: 4px;
}

.imglastclass {
  padding-right: 0px;
}

.masonry {
  -moz-column-count: 4;
  /* 火狐 */
  -webkit-column-count: 4;
  /* Safari 和 谷歌 */
  column-count: 4;
  -moz-column-gap: 1em;
  -webkit-column-gap: 1em;
  column-gap: 1em;
  width: 100%;
  margin: 1em auto;
}

.item {
  padding: 1em;
  margin-bottom: 1em;
  -moz-page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
  break-inside: avoid;
  background: #b5ffa1;
}

.pc {
  /* display: flex; */
}

.mobile {
  display: none;
}

@media (max-width: 575px) {
  .pc {
    display: none !important;
  }

  .mobile {
    display: block !important;
  }
}

@media (min-width: 576px) {
  .masonry {
    column-count: 1;
  }
}

@media (min-width: 768px) {
  .masonry {
    column-count: 2;
  }
}

@media (min-width: 992px) {
  .masonry {
    column-count: 2;
  }
}

@media (min-width: 1344px) {
  .masonry {
    column-count: 4;
  }
}

.left {
  float: left;
}

#album-view {
  padding-top: initial;
}

.section-subBysusan {
  width: 100%;
}

.inputPageDiv>>>.el-input-number--mini {
  width: 40px;
}

.inputPageDiv>>>.el-input-number--mini>.el-input--mini>.el-input__inner {
  height: 24px;
  line-height: 24px;
  padding: 0px;
  width: 40px;
}

.aaaaa:hover {
  cursor: pointer;
}
</style>

<style>
.abcd {
  width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/Album/albumviewPhotostream.vue